import { IPaginatedResponse, IResponse } from "../../../model";
import ServiceBase from "../../../servicebase";
import { IPrestacion, IPrestacionTipo } from "../model/IPrestacion";

export default class PrestacionService extends ServiceBase {
  all = () : Promise<IResponse<IPrestacion[]>> => 
    this.GetFetch<IResponse<IPrestacion[]>>('entity/prestacion/all', {});

  get = (data:{ id?: number }) : Promise<IResponse<IPrestacion>> => 
    this.GetFetch<IResponse<IPrestacion>>('entity/prestacion', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string,
    id?: number, nombre?: string, codigo?: string, activo?: boolean }) : Promise<IPaginatedResponse<IPrestacion>> => 
    this.GetFetch<IPaginatedResponse<IPrestacion>>('entity/prestacion/find', data);

  upsert = (data:IPrestacion) : Promise<IResponse<IPrestacion>> => 
    this.PostFetch<IResponse<IPrestacion>>('entity/prestacion', data);

  delete = (data:{ id:number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/prestacion', data);

  tipo = {
    all: () : Promise<IResponse<IPrestacionTipo[]>> => 
      this.GetFetch<IResponse<IPrestacionTipo[]>>('entity/prestaciontipo/all', {})
  }
}
